'use client';
import EventApi from '@/api/event';
import {
  handleLogin,
  loginState,
  handleUserInfo as loginUserInfo,
} from '@/utils/event/util';
import globalDomains from '@/utils/global-domains';
import {isWebview} from '@/utils/helper';
import throwToast from '@/utils/ui/toast';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {useEffect, useState} from 'react';
import MissionCompleteDayList from './components/MissionCompleteDayList';
import checkDevice from '../../utils/checkDevice';
import {bridgeHandler, deepLinkHandler} from '../../utils/bridgeHandler';
import PersonaList from '@/app/(events)/events/soopi/components/PersonaList';
import styles from './styles.module.css';
import Footer from './components/Footer';

const SoopiDailyMission = ({onBodyId}) => {
  const [loading, setLoading] = useState(false);
  const [userNick, setUserNick] = useState('');
  const [userId, setUserId] = useState('');
  const [missionData, setMissionData] = useState({
    allDays: [],
    allPersona: [],
    days: [],
    persona: [],
  });
  useEffect(() => {
    /**
     * 초기 로드시 body id 셋팅
     */
    onBodyId && onBodyId(styles.body);
    setLoading(true);
  }, [onBodyId]);

  useEffect(() => {
    AOS.init();

    const fetchData = async () => {
      const data = await EventApi.get('/soopi/daily_mission.php');
      if (data.result === 1) {
        setMissionData(data.data);
      }
    };
    fetchData();
  }, []);

  // 로그인 정보 셋팅
  useEffect(() => {
    if (loginState) {
      const {userId, userNickname} = loginUserInfo();
      setUserNick(userNickname);
      setUserId(userId);
    }
  }, [loginState]);

  const onShareLink = () => {
    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      navigator.clipboard
        .writeText(`${globalDomains.WWW_AFREECATV}/events/soopi/daily-mission`)
        .then(() => {
          if (!isWebview) {
            throwToast('미션 이벤트의 URL이 복사되었어요');
          } else {
            bridgeHandler('THROW_TOAST', {
              msg: '미션 이벤트의 URL이 복사되었어요',
            });
          }
        })
        .catch((err) => {
          if (!isWebview) {
            throwToast('URL 복사 실패');
          } else {
            bridgeHandler('THROW_TOAST', {msg: 'URL 복사 실패'});
          }
        });
    }
  };

  const onDetail = () => {
    if (checkDevice() === 'Web') {
      window.open(`${globalDomains.BJ_AFREECATV}/soopi/post/155292059`);
    } else {
      deepLinkHandler('NAVIGATE_BROWSER', {
        url: `${globalDomains.BJ_AFREECATV}/soopi/post/155292059`,
      });
    }
  };

  const handleClipboard = () => {
    if (!isWebview) {
      navigator.clipboard
        .writeText(`${globalDomains.WWW_AFREECATV}/events/soopi/daily-mission`)
        .then(() => {
          throwToast('미션 이벤트의 URL이 복사되었어요');
        })
        .catch((err) => {
          throwToast('URL 복사 실패');
        });
    }
  };
  return (
    loading && (
      <>
        <div id='wrap'>
          <header className={styles.header}>
            <div className={styles.inner}>
              <h1>
                <a href={globalDomains.WWW_AFREECATV} target='_blank'>
                  SOOP
                </a>
              </h1>
              <div className={styles.login_wrap}>
                {loginState ? (
                  <>
                    <button
                      type='button'
                      className={styles.account}
                      onClick={handleLogin}>
                      로그아웃
                    </button>
                  </>
                ) : (
                  <button
                    type='button'
                    className={styles.account}
                    onClick={handleLogin}>
                    로그인
                  </button>
                )}
              </div>
            </div>
          </header>
          <div id='conts'>
            {/* Visual Area */}
            <section className={styles.visual_area}>
              <div className={styles.inn}>
                <div className={styles.visual}>
                  <h2 className={styles.item_txt}>
                    <i
                      className={`${styles.ele_1} ${styles.ele}`}
                      data-aos='fade-left'
                      data-aos-delay='100'>
                      SOOPi가 학습한 34명 모델 스트리머의 열혈&구독팬 에게
                    </i>
                    <i
                      className={`${styles.ele_2} ${styles.ele}`}
                      data-aos='fade-left'
                      data-aos-delay='250'>
                      플스 5
                    </i>
                    <i
                      className={`${styles.ele_3} ${styles.ele}`}
                      data-aos='fade-left'
                      data-aos-delay='500'>
                      쏜다!
                    </i>
                  </h2>
                  <div className={styles.item_img}>
                    <i className={styles.ele_gift}></i>
                    <i className={styles.ele_gd}></i>
                    <i className={styles.ele_msg}></i>
                  </div>
                </div>
                <div className={styles.date_wrap}>
                  <p className={styles.period}>4/30(수) - 5/28(수)</p>
                  <span className={styles.winner}>당첨자 발표 6/4(수)</span>
                </div>
                <div className={styles.desc_box}>
                  <strong className={styles.tit}>
                    내가 좋아하는 스트리머가
                    <br />
                    <em>나만의 AI 영상 비서</em>가 된다면?
                  </strong>
                  <p className={styles.desc}>
                    아래 미션을 완료하여 상상을 현실로 만들고
                    <br />
                    <strong>플레이스테이션5 Pro</strong>까지 받아가세요!
                  </p>
                </div>
              </div>
            </section>

            {/* MISSION 01 */}
            <section className={styles.mission1_area}>
              <div className={styles.inn} data-aos='fade-up'>
                <div className={styles.label_mission}>
                  <strong>MISSION 01</strong>
                </div>
                <h3>
                  SOOPi가 학습한
                  <br />
                  스트리머 구독팬 되기
                </h3>
                <p className={styles.desc}>
                  이미 아래 스트리머의 열혈팬 & 구독팬이라면
                  <br />
                  <strong>MISSION 02</strong>를 진행해 주세요!
                </p>
                {userId === '' && (
                  <button
                    type='button'
                    onClick={handleLogin}
                    className={styles.login}>
                    <span>로그인이 필요합니다.</span>
                  </button>
                )}
                {userId && missionData.persona?.length === 0 && (
                  <div className={styles.mission_state}>
                    <span>
                      구독하기 <em>미션 진행 중</em>
                    </span>
                  </div>
                )}
                {userId && missionData.persona?.length > 0 && (
                  <div className={`${styles.mission_state} ${styles.done}`}>
                    <span>
                      구독하기 <em>미션 완료!</em>
                    </span>
                  </div>
                )}
                <PersonaList
                  userId={userId}
                  allPersonaList={missionData.allPersona}
                />
              </div>
            </section>

            {/* MISSION 02 */}
            <section className={styles.mission2_area}>
              <div className={styles.inn} data-aos='fade-up'>
                <div className={styles.label_mission}>
                  <strong>MISSION 02</strong>
                </div>
                <h3>SOOPi와 대화하기</h3>
                <p className={styles.desc}>
                  이벤트 기간 동안 <em>SOOPi와 3턴 이상 대화</em>하면
                  <br />
                  그날의 일일 미션이 완료됩니다.
                  <em>10일 이상 참여 시 미션 2 완료!</em>
                  <br />
                  <strong>매일 매일 빠짐없이 참여하면 추첨 확률 UP</strong>
                </p>

                {userId === '' && (
                  <button
                    type='button'
                    onClick={handleLogin}
                    className={styles.login}>
                    <span>로그인이 필요합니다.</span>
                  </button>
                )}
                {userId && missionData.days?.length < 10 && (
                  <div className={styles.mission_state}>
                    <span>
                      대화하기 <em>미션 진행 중</em>
                    </span>
                  </div>
                )}
                {userId && missionData.days?.length >= 10 && (
                  <div className={`${styles.mission_state} ${styles.done}`}>
                    <span>
                      대화하기 <em>미션 완료!</em>
                    </span>
                  </div>
                )}

                <MissionCompleteDayList
                  allDays={missionData.allDays}
                  completeDays={missionData.days}
                />
              </div>
            </section>

            {/* 경품 영역 */}
            <section className={styles.gift_item_area}>
              <div className={styles.inn} data-aos='fade-up'>
                <h3>이벤트 경품</h3>
                <i className={styles.ele_gift1}></i>
                <div className={styles.info_box}>
                  <div className={styles.desc}>
                    <p>
                      <span className={styles.label_mission1}>MISSION 01</span>
                      만 완료해도
                    </p>
                    <p>
                      <strong>100명을 추첨</strong>하여 문화상품권 1만원 권 증정
                    </p>
                  </div>
                  <img
                    src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/soopi_mission/img/gift_card.png`}
                    alt='문화상품권'
                    className={styles.item_card}
                  />
                  <span className={styles.item_tit}>문화상품권 1만원</span>
                </div>
                <div className={styles.info_box}>
                  <div className={styles.desc}>
                    <p>
                      <span className={styles.label_mission2}>MISSION 02</span>
                      까지 완료하면
                    </p>
                    <p>
                      <strong>3명을 추첨</strong>하여 플레이스테이션5 PRO 증정
                    </p>
                  </div>
                  <img
                    src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/soopi_mission/img/gift_ps.png`}
                    alt='플스5'
                    className={styles.item_ps}
                  />
                  <span className={styles.item_tit}>플레이스테이션5 PRO</span>
                </div>
                <i className={styles.ele_gift2}></i>
                <p className={styles.noti_txt}>
                  매일 일일 미션을 빠짐없이 참여하면 추첨 확률 UP
                </p>
              </div>
            </section>

            {/* 일정 영역 */}
            <section className={styles.schedule_area}>
              <div className={styles.inn}>
                <h3>이벤트 일정</h3>
                <div className={styles.event_detail}>
                  <dl>
                    <dt>이벤트 기간</dt>
                    <dd>2025.4.30(수) ~ 2025.5.28(수)</dd>
                  </dl>
                  <dl>
                    <dt>당첨자 발표</dt>
                    <dd>2025.6.4(수)</dd>
                  </dl>
                </div>
                <button
                  onClick={onDetail}
                  type='button'
                  className={styles.detail}>
                  SOOPi 자세히 알아보기
                </button>
                <button
                  onClick={onShareLink}
                  type='button'
                  className={styles.share}>
                  이벤트 링크 공유하기
                </button>
              </div>
            </section>

            {/* 주의사항 영역 */}
            <section className={styles.notice_area}>
              <div className={styles.inn}>
                <h3>유의사항</h3>
                <ul>
                  <li>
                    본 이벤트는 사정에 의하여 사전 고지 없이 내용 변경 또는 조기
                    종료될 수 있습니다.
                  </li>
                  <li>
                    SOOPi 서비스를 직접 구독하여 이용한 유저에게만 상품
                    지급됩니다.
                  </li>
                  <li>당첨자 본인 명의 계정에만 경품이 지급됩니다.</li>
                  <li>
                    이벤트 당첨자는 쪽지로 개별 안내 예정이오니 사전에 쪽지 수신
                    거부를 해제해주세요.
                  </li>
                  <li>
                    경품 지급과정에 필요한 정보를 요청할 예정입니다. 요구되는
                    정보를 전달주셔야 경품 지급이 가능합니다.
                  </li>
                  <li>
                    5만원 이상의 경품 당첨 시, 소비자의 제세공과금 납부가
                    필요합니다.
                  </li>
                  <li>
                    경품 색상은 선택 불가능하며 수급 사정에 따라 동일 가격대
                    제품으로 대체될 수 있습니다.
                  </li>
                </ul>
              </div>
            </section>
          </div>
          <footer className={styles.footer}>© SOOP Corp.</footer>
        </div>
      </>
    )
  );
};

export default SoopiDailyMission;
